import climate from "../../img/events/klimabayern_Smartmap_Icon.svg";
import busevNoRealtimeData from "../../img/lines/busev-gray.svg";
import busev from "../../img/lines/busevkreis.svg";
import busevArrow from "../../img/lines/busevpfeil.svg";
import s1CircleNoRealtimeData from "../../img/lines/s1kreis-gray.svg";
import s1Circle from "../../img/lines/s1kreis.svg";
import s1Arrow from "../../img/lines/s1pfeil.svg";
import s20CircleNoRealtimeData from "../../img/lines/s20kreis-gray.svg";
import s20Circle from "../../img/lines/s20kreis.svg";
import s20Arrow from "../../img/lines/s20pfeil.svg";
import s2CircleNoRealtimeData from "../../img/lines/s2kreis-gray.svg";
import s2Circle from "../../img/lines/s2kreis.svg";
import s2Arrow from "../../img/lines/s2pfeil.svg";
import s3CircleNoRealtimeData from "../../img/lines/s3kreis-gray.svg";
import s3Circle from "../../img/lines/s3kreis.svg";
import s3Arrow from "../../img/lines/s3pfeil.svg";
import s4CircleNoRealtimeData from "../../img/lines/s4kreis-gray.svg";
import s4Circle from "../../img/lines/s4kreis.svg";
import s4Arrow from "../../img/lines/s4pfeil.svg";
import s5CircleNoRealtimeData from "../../img/lines/s5kreis-gray.svg";
import s5Circle from "../../img/lines/s5kreis.svg";
import s5Arrow from "../../img/lines/s5pfeil.svg";
import s6CircleNoRealtimeData from "../../img/lines/s6kreis-gray.svg";
import s6Circle from "../../img/lines/s6kreis.svg";
import s6Arrow from "../../img/lines/s6pfeil.svg";
import s7CircleNoRealtimeData from "../../img/lines/s7kreis-gray.svg";
import s7Circle from "../../img/lines/s7kreis.svg";
import s7Arrow from "../../img/lines/s7pfeil.svg";
import s8CircleNoRealtimeData from "../../img/lines/s8kreis-gray.svg";
import s8Circle from "../../img/lines/s8kreis.svg";
import s8Arrow from "../../img/lines/s8pfeil.svg";
import sCircleNoRealtimeData from "../../img/lines/skreis-gray.svg";
// Standard icons
import sCircle from "../../img/lines/skreis.svg";

import type { MapLineIcons } from "../common";

// Christmas icons
// import sCircle from '../../img/lines/skreis_christmas.svg';
// import s1Circle from '../../img/lines/s1kreis_christmas.svg';
// import s2Circle from '../../img/lines/s2kreis_christmas.svg';
// import s3Circle from '../../img/lines/s3kreis_christmas.svg';
// import s4Circle from '../../img/lines/s4kreis_christmas.svg';
// import s6Circle from '../../img/lines/s6kreis_christmas.svg';
// import s7Circle from '../../img/lines/s7kreis_christmas.svg';
// import s8Circle from '../../img/lines/s8kreis_christmas.svg';
// import sCircleNoRealtimeData from '../../img/lines/skreis-gray_christmas.svg';
// import s1CircleNoRealtimeData from '../../img/lines/s1kreis-gray_christmas.svg';
// import s2CircleNoRealtimeData from '../../img/lines/s2kreis-gray_christmas.svg';
// import s3CircleNoRealtimeData from '../../img/lines/s3kreis-gray_christmas.svg';
// import s4CircleNoRealtimeData from '../../img/lines/s4kreis-gray_christmas.svg';
// import s6CircleNoRealtimeData from '../../img/lines/s6kreis-gray_christmas.svg';
// import s7CircleNoRealtimeData from '../../img/lines/s7kreis-gray_christmas.svg';
// import s8CircleNoRealtimeData from '../../img/lines/s8kreis-gray_christmas.svg';
// import s20CircleNoRealtimeData from '../../img/lines/s20kreis-gray_christmas.svg';

const mapLineIcons: MapLineIcons = {
  BusEV: {
    arrow: busevArrow,
    circle: busev,
  },
  BusEV_NoRealtime: {
    arrow: busevArrow,
    circle: busevNoRealtimeData,
  },
  Climate: {
    arrow: s6Arrow,
    circle: climate,
  },
  Climate_NoRealtime: {
    arrow: s6Arrow,
    circle: climate,
  },
  S: {
    arrow: s6Arrow,
    circle: sCircle,
  },
  S_NoRealtime: {
    arrow: s6Arrow,
    circle: sCircleNoRealtimeData,
  },
  S1: {
    arrow: s1Arrow,
    circle: s1Circle,
  },
  S1_NoRealtime: {
    arrow: s1Arrow,
    circle: s1CircleNoRealtimeData,
  },
  S2: {
    arrow: s2Arrow,
    circle: s2Circle,
  },
  S2_NoRealtime: {
    arrow: s2Arrow,
    circle: s2CircleNoRealtimeData,
  },
  S20: {
    arrow: s20Arrow,
    circle: s20Circle,
  },
  S20_NoRealtime: {
    arrow: s20Arrow,
    circle: s20CircleNoRealtimeData,
  },
  S3: {
    arrow: s3Arrow,
    circle: s3Circle,
  },
  S3_NoRealtime: {
    arrow: s3Arrow,
    circle: s3CircleNoRealtimeData,
  },
  S4: {
    arrow: s4Arrow,
    circle: s4Circle,
  },
  S4_NoRealtime: {
    arrow: s4Arrow,
    circle: s4CircleNoRealtimeData,
  },
  S5: {
    arrow: s5Arrow,
    circle: s5Circle,
  },
  S5_NoRealtime: {
    arrow: s5Arrow,
    circle: s5CircleNoRealtimeData,
  },
  S6: {
    arrow: s6Arrow,
    circle: s6Circle,
  },
  S6_NoRealtime: {
    arrow: s6Arrow,
    circle: s6CircleNoRealtimeData,
  },
  S7: {
    arrow: s7Arrow,
    circle: s7Circle,
  },
  S7_NoRealtime: {
    arrow: s7Arrow,
    circle: s7CircleNoRealtimeData,
  },
  S8: {
    arrow: s8Arrow,
    circle: s8Circle,
  },
  S8_NoRealtime: {
    arrow: s8Arrow,
    circle: s8CircleNoRealtimeData,
  },
};

// For SBAHNMW-885, we automate the creation of other bus lines.
[
  "S1",
  "S2",
  "S3",
  "S4",
  "S5",
  "S6",
  "S7",
  "S8",
  "S20",
  "S",
  "EV",
  "SEV",
].forEach((line) => {
  mapLineIcons[`Bus${line}`] = {
    arrow: busevArrow,
    circle: busev,
  };
  mapLineIcons[`Bus${line}_NoRealtime`] = {
    arrow: busevArrow,
    circle: busevNoRealtimeData,
  };
});

export default mapLineIcons;
